// Generated by scripts/generate-web-routes.ts. Page behavior lives in app/.
import { createFileRoute } from "@tanstack/react-router";
import Page from "@/app/(portal)/advanced-agent/page";
import { parseAtlasSearch } from "@/lib/navigation-target";
import { toPageHead } from "@/lib/page-metadata";
import { loadRoutePage } from "@/lib/page-route";
import { buildRootMetadata } from "@/lib/site-metadata";
import Loading from "@/app/(portal)/advanced-agent/loading";

export const Route = createFileRoute("/_portal/advanced-agent/")({
  loaderDeps: ({ search }) => search,
  loader: ({ params, location }) => loadRoutePage(
    () => import("@/app/(portal)/advanced-agent/page"),
    { params, searchParams: parseAtlasSearch(location.searchStr) },
    "/_portal/advanced-agent/",
  ),
  head: ({ loaderData }) => toPageHead(loaderData?.metadata ?? {}, {
    parent: buildRootMetadata(),
  }),
  component: PageRoute,
  pendingComponent: Loading,
});

function PageRoute() {
  return <Page data={Route.useLoaderData().data} />;
}
